// @ts-nocheck
import React from 'react';
import {
  Activity,
  ArrowUpRight,
  Boxes,
  Braces,
  Cable,
  ChartNoAxesCombined,
  CheckCheck,
  ClipboardCheck,
  Cpu,
  Database,
  DraftingCompass,
  Gauge,
  GraduationCap,
  LifeBuoy,
  PackageCheck,
  PanelsTopLeft,
  PlugZap,
  ScanLine,
  ScanSearch,
  Settings,
  ShieldCheck,
  Tags,
  TestTubeDiagonal,
  Wrench,
} from 'lucide-react';

const iconMap = {
  analysis: ScanSearch,
  audit: ClipboardCheck,
  test: TestTubeDiagonal,
  technology: Cpu,
  design: DraftingCompass,
  integration: Cable,
  launch: PlugZap,
  control: CheckCheck,
  training: GraduationCap,
  handover: PackageCheck,
  support: LifeBuoy,
  marking: ScanLine,
  scan: ScanLine,
  serialization: Database,
  labeling: Tags,
  packaging: Boxes,
  vision: ScanSearch,
  service: Wrench,
  diagnostics: Activity,
  maintenance: Settings,
  software: PanelsTopLeft,
  database: Database,
  settings: Settings,
  evidence: ShieldCheck,
  compatibility: Braces,
  performance: Gauge,
  automation: ChartNoAxesCombined,
};

export function VisualIcon({ name = 'analysis', className = '' }) {
  const Icon = iconMap[name] || ScanSearch;
  return <span className={`visual-icon ${className}`.trim()} aria-hidden="true"><Icon/></span>;
}

export function ArrowIcon({ className = '' }) {
  return <ArrowUpRight className={`arrow-icon ${className}`.trim()} aria-hidden="true"/>;
}
